module.exports = __webpack_public_path__ + "ICHRA Flyer.pdf";